import { Insight } from 'models/insight';

/**
 * The Insight process row: what was asked for, and the answers composed so far for this entity,
 * one per focus and language.
 *
 * Deliberately not part of `CopilotPanelProcessStateData`: that union is closed on process states
 * that carry a conversation, and this one carries none - the card asks and reads, it does not talk.
 */
export class TenantProcessStateInsight {
  /** Which insight was asked for. The entity-wide one is `entity`. */
  focus: string;

  /** True when a fresh composition was asked for although the cached one still fits. */
  force: boolean;

  /** The composed answers, keyed "{focus}:{lang}". */
  insights: Map<string, Insight>;

  constructor() {
    this.focus = '';
    this.force = false;
    this.insights = new Map<string, Insight>();
  }
}
